import { BarsOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

const roleColumn = (a) => {
  if (a.vlieger && a.vlieger.group_keys?.includes("gastvlieger"))
    return <Tag>{$t("gast")}</Tag>;
  if (a.vlieger && a.vlieger.tag === "dbo")
    return <Tag color="gold">{$t("dbo")}</Tag>;
  if (a.vlieger && a.vlieger.tag === "solist")
    return <Tag color="gold">{$t("solo")}</Tag>;
  if (a.as_instructeur) return <Tag color="gold">{$t("Ins")}</Tag>;

  return <p style={{ paddingLeft: 4 }} />;
};

const getGroupAbbreviation = (group, group_name_lookup) => {
  // abbreviates group. Lierist > lie, Lier_instructeur > l_ins
  let name = group_name_lookup[group] || group;
  if (name.indexOf("_") > 0) {
    const split = name.split("_");
    return name.slice(0, 1) + "_" + split[1].slice(0, 3);
  } else {
    return name.slice(0, 3);
  }
};

const valueOrDefault = (check, showTag) => {
  if (check) return showTag;
  return <p style={{ paddingLeft: 4 }} />;
};

export const PrintRow = ({
  groups_aanmeld,
  a,
  key,
  types,
  squeeze,
  skipLabels,
  group_name_lookup,
  niet_vliegend,
  userDienstLookup,
}) => {
  // iterate over all kisten, check abbreviation and reduce doubles.
  let requested_types = a.kist
    .reduce((all, kist) => {
      const a = types[kist] || kist;
      !all.includes(a) && all.push(a);
      return all;
    }, [])
    .sort();

  if (requested_types.length === 0) requested_types = [""];

  return (
    <div key={key} className={squeeze ? "record squeeze" : "record"}>
      <div className="vlieger">
        <div
          className="row"
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <p className="name bold">
            <span className="aanwezig">&nbsp;</span>
            {niet_vliegend && (
              <Tag style={{ fontWeight: 300 }}>{$t("N.V.")}</Tag>
            )}
            {a.checkstart && <Tag style={{ fontWeight: 300 }}>{$t("tr")}</Tag>}
            {a.overland && <Tag style={{ fontWeight: 300 }}>{$t("Ovl")}</Tag>}
            {a.vlieger.name}
          </p>

          {!niet_vliegend && (
            <div className="row">
              {skipLabels && (
                <div className="tags">
                  <Tag className="transparent gray" style={{ marginRight: 12 }}>
                    {$t("prive")}
                  </Tag>
                </div>
              )}

              <span className="start" />
              <span className="start" />
              <span className="start" />

              {!skipLabels && (
                <>
                  <span className="start" />
                  <span className="start" />
                  <span className="start" />
                  <span className="start" />
                  <span className="start" />
                </>
              )}
            </div>
          )}
        </div>

        {!skipLabels && (
          <div className="tags">
            <div style={{ width: 30 }}>{roleColumn(a)}</div>

            {groups_aanmeld &&
              groups_aanmeld.length > 1 &&
              groups_aanmeld.split(",").map((g, idx) => (
                <div key={idx} style={{ width: 25 }}>
                  {valueOrDefault(
                    a.vlieger.group_keys?.includes(g),
                    <Tag>{getGroupAbbreviation(g, group_name_lookup)}</Tag>
                  )}
                </div>
              ))}

            {userDienstLookup &&
              userDienstLookup[a.vlieger.id]?.map((dienst, idx) => (
                <Tag
                  key={idx}
                  color="geekblue"
                  style={{ lineHeight: 0.9 }}
                  icon={<BarsOutlined />}
                >
                  {dienst.name}
                </Tag>
              ))}

            <div className="column">
              <p>
                {requested_types.slice(0, 3).map((kist, key) => (
                  <Tag className="transparent gray" key={key}>
                    {kist === "privé" ? $t("privé") : kist}
                  </Tag>
                ))}

                {a.van && <Tag className="transparent">+{a.van}</Tag>}
                {a.tot && <Tag className="transparent">-{a.tot}</Tag>}
              </p>

              {a.opmerking && (
                <p className="transparent supersmall">
                  {a.opmerking.substr(0, 50)}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
